/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'ContentHubMarketing',

    props: {
        params: {
            type: Object,
            required: true
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-hub-marketing" }, [
    _vm._m(0),
    _c("div", { staticClass: "banner" }, [
      _c("img", {
        attrs: {
          srcset: _vm.$utils.assets.imagePath(
            "content-hub-marketing.png",
            "2x"
          ),
          alt: "The on-demand content hub that feels live",
        },
      }),
    ]),
    _vm._m(1),
    _vm._m(2),
    _vm._m(3),
  ])
}
var __vue_staticRenderFns__ = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "heading" }, [
      _c("header", [
        _c("h1", [_vm._v("The on-demand content hub that feels live")]),
        _c("p", [
          _vm._v(
            "Let your audience relive real event experiences. Boost your on-demand content engagement with a centralized, gated hub. Accessible anywhere, anytime."
          ),
        ]),
        _c("div", { staticClass: "features" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "title" }, [
              _c("i", { staticClass: "ic-media" }),
            ]),
            _c("div", { staticClass: "body" }, [
              _vm._v("Turn live events into on-demand videos effortlessly"),
            ]),
          ]),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "title" }, [
              _c("i", { staticClass: "ic-key" }),
            ]),
            _c("div", { staticClass: "body" }, [
              _vm._v("Share gated content that's 100% compliant and secure"),
            ]),
          ]),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "title" }, [
              _c("i", { staticClass: "ic-pie-chart-2" }),
            ]),
            _c("div", { staticClass: "body" }, [
              _vm._v("Find out who consumes what to drive content strategies"),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "actions" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-primary",
          attrs: {
            href: "https://spotme.com/contact-sales/?utm_campaign=Content%20Hub%20Promo%20Backstage&utm_source=backstage&utm_medium=landing-page&utm_content=content-hub-promo",
            target: "_blank",
            rel: "noopener noreferrer",
          },
        },
        [_vm._v("Request a demo")]
      ),
      _c(
        "a",
        {
          staticClass: "btn",
          attrs: {
            href: "https://spotme.com/on-demand-content-hub/?utm_campaign=Content%20Hub%20Promo%20Backstage&utm_source=backstage&utm_medium=landing-page&utm_content=content-hub-promo",
            target: "_blank",
            rel: "noopener noreferrer",
          },
        },
        [_vm._v("See it in action")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "more" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://spotme.com/product/content-hub/?utm_campaign=Content%20Hub%20Promo%20Backstage&utm_source=backstage&utm_medium=landing-page&utm_content=content-hub-promo",
            target: "_blank",
            rel: "noopener noreferrer",
          },
        },
        [_vm._v("View more info")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gains" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "icon" }, [
            _c("i", { staticClass: "ic-qna" }),
          ]),
          _c("div", { staticClass: "text" }, [
            _vm._v("Liven up your on-demand content"),
          ]),
        ]),
        _c("div", { staticClass: "body" }, [
          _c("p", [
            _vm._v(
              "Enliven on-demand viewing with live engagement replay to keep your audience engaged and boost satisfaction."
            ),
          ]),
          _c("p", [
            _vm._v(
              "Let viewers clap along while watching on-demand content and show polls, Q&A, and claps at the time they happened during the live recording."
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "icon" }, [
            _c("i", { staticClass: "ic-tools" }),
          ]),
          _c("div", { staticClass: "text" }, [
            _vm._v("From live to on-demand in just a few clicks"),
          ]),
        ]),
        _c("div", { staticClass: "body" }, [
          _c("p", [
            _vm._v(
              "Say goodbye to costly, time-consuming ways of sharing on-demand content with your audience."
            ),
          ]),
          _c("p", [
            _vm._v(
              "Publish recorded live events on your content hub and give your target market what they want, fast."
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "icon" }, [
            _c("i", { staticClass: "ic-bar-chart" }),
          ]),
          _c("div", { staticClass: "text" }, [
            _vm._v("Deeper insights with first-party data"),
          ]),
        ]),
        _c("div", { staticClass: "body" }, [
          _c("p", [
            _vm._v(
              "In just 3 clicks, download details about what your audience consumes and engages with. Down to the individual."
            ),
          ]),
          _c("p", [
            _vm._v(
              "Analyze data to propel future content planning, create curated content your consumers want, and start personalized conversations with leads."
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "icon" }, [
            _c("i", { staticClass: "ic-lock" }),
          ]),
          _c("div", { staticClass: "text" }, [
            _vm._v("100% compliance with gated content"),
          ]),
        ]),
        _c("div", { staticClass: "body" }, [
          _c("p", [
            _vm._v(
              "Keep your on-demand content secure by choosing who has access. Invite your customers and leads with a private magic link."
            ),
          ]),
          _c("p", [
            _vm._v(
              "Share approved content in a safe space and comply with enterprise-grade security by not allowing consumers to make public comments."
            ),
          ]),
        ]),
      ]),
    ])
  },
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/ContentHubMarketing.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__